import { Component, Input, OnInit } from '@angular/core';
import { NodoEntity, FiltrosFormatoAsistencialEntity, ServicioFormatoAsistencialService, ValorPreguntaEntity } from 'src/app/services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.css']
})
export class AreaComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  descripcion: string;
  valor: string;

  constructor(private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.valor = '';
      this.descripcion = null;
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.descripcion = this.nodo.descripcion;
    if (this.nodo.datos && this.nodo.datos.length > 0 && 
        this.nodo.datos[0].valor && this.nodo.datos[0].valor.length > 0) {
      this.valor = this.nodo.datos[0].valor;
    } else {
      if (this.filtros.diligenciados) {
        setTimeout(() => {
          this.onDelete(this.nodo, this.filtros.tta);
        }, 50);
      } else {
        this.valor = this.onDefaultValue();
      }
    }
  }

  onDefaultValue() {
    const defaultValue = Number(this.nodo.valor);
    const dato = this.servicioFormato.valoresPregunta ? this.servicioFormato.valoresPregunta.find((v: ValorPreguntaEntity) => v.unco === defaultValue) : null;
    return dato ? ( dato.descripcionDetallada ? dato.descripcionDetallada : (dato.descripcion ? dato.descripcion : '')) : '';
  }

  onDelete(nodo: NodoEntity, tta: number) { }

}
